module.exports = __webpack_public_path__ + "img/member-icon2.97755dc2.png";